import React, { useState, useEffect, useRef } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Row,
  InputGroup
} from "react-bootstrap";
import { connect } from 'react-redux';
import "components/custom.css";
import API from "api.js";
import { Navigate, NavLink } from "react-router-dom";
import { setToken, setUser, setSub, setAlert } from 'action/index.js';
import SimpleReactValidator from "simple-react-validator";

const mapStateToProps = (state) => {
  return {
    token: state.token
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (tok) => dispatch(setToken(tok)),
    setUser: (user) => dispatch(setUser(user)),
    setSub: (sub) => dispatch(setSub(sub)),
    setAlert: (val) => dispatch(setAlert(val)),
  };
};

const ResetPassword = (props) => {
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [confirmTouched, setConfirmTouched] = useState(false);
  const [, setRender] = useState(false);
  const forceUpdate = () => setRender((prev) => !prev);

  const validator = useRef(
    new SimpleReactValidator({
      validators: {
        passwordStrong: {
          rule: (val) => {
            if (!val) return false;
            const regex =
              /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
            return regex.test(val);
          },
          message:
            "Password must be at least 6 characters and include 1 uppercase letter, 1 number, and 1 special character",
        },
        passwordMatch: {
          rule: (val) => val === password,
          message: "Passwords do not match.",
        },
      },
    })
  );
  // Ensure the validator has the current password for the match rule to avoid stale closures
  validator.current.rules.passwordMatch.rule = (val) => val === password;


  useEffect(() => {
    document.body.classList.toggle("login-page");

    return () => {
      document.body.classList.toggle("login-page");
    };
  }, []);

  const postLogIn = async (e) => {

    e.preventDefault();
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate();
      return;
    }
    var bodyFormData = new FormData();
    bodyFormData.set('otp', otp);
    bodyFormData.set('password', password);
    bodyFormData.set('password_confirmation', confirmPassword);
    let res = null;
    try {
      res = await API({
        method: 'POST',
        url: '/reset-password',
        data: bodyFormData
      })
      if (res.status === 200) {
        const expires = new Date();
        expires.setDate(Date.now() + 1000 * 60 * 60);
        setSuccess(true);
        props.setAlert({
          flag: true,
          type: 1,
          message: res?.data?.message || "Password reset successful",
        });
      }
    } catch (error) {
      const resp = error?.response;

      if (resp?.status === 422 && resp?.data?.errors) {
        setFieldErrors(resp.data.errors || {});
        return;
      }

      props.setAlert({
        flag: true,
        type: 2,
        message: resp?.data?.message || "Something went wrong. Please try again.",
      });
    };

  }

  const changeInput = (e) => {
    let { name, value } = e.target;
    if (name === 'otp') setOtp(value);
    else if (name === 'password') {
      setPassword(value);
    } else if (name === 'confirmPassword') {
      setConfirmPassword(value);
    }
    setFieldErrors((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  if (success) {
    return (<Navigate to="/auth/login" replace />);
  }

  return (
    <>
      <section className="bannerOuter">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-center">
              <h1>Login</h1>
              <span>Login your account</span>
            </div>
          </div>
        </div>
      </section>
      <section className="contentOuter">
        <div className="login-page">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" lg={4} md={6}>
                <Form>
                  <Card className="card-login">
                    <Card.Header>
                      <Card.Header>
                        <h3 className="header text-center">Reset Password</h3>
                      </Card.Header>
                    </Card.Header>
                    <Card.Body>
                      <InputGroup className="mb-3 flex-column">
                        <div className="d-flex">
                          <InputGroup.Text>
                            <i className="nc-icon nc-single-02" />
                          </InputGroup.Text>
                          <Form.Control
                            placeholder="Verification Code"
                            type="text"
                            name="otp"
                            value={otp}
                            onChange={(e) => {
                              changeInput(e);
                              validator.current.showMessageFor("Verification Code");
                            }}
                          />
                        </div>
                        {validator.current.message(
                          "Verification Code",
                          otp,
                          "required"
                        )}
                        {fieldErrors?.otp && (
                          <small className="text-danger d-block mt-1">{fieldErrors.otp[0]}</small>
                        )}
                      </InputGroup>
                      <InputGroup className="mb-3 flex-column">
                        <div className="d-flex">
                          <InputGroup.Text>
                            <i className="nc-icon nc-key-25" />
                          </InputGroup.Text>
                          <Form.Control
                            placeholder="Password"
                            type="password"
                            name="password"
                            value={password}
                            onChange={(e) => {
                              changeInput(e);
                              validator.current.showMessageFor("Password");
                            }}
                            autoComplete="off"
                          />
                        </div>
                        {validator.current.message(
                          "Password",
                          password,
                          "required|passwordStrong"
                        )}
                        {fieldErrors?.password && (
                          <small className="text-danger d-block mt-1">{fieldErrors.password[0]}</small>
                        )}
                      </InputGroup>
                      <InputGroup className="mb-3 flex-column">
                        <div className="d-flex">
                          <InputGroup.Text>
                            <i className="nc-icon nc-key-25" />
                          </InputGroup.Text>
                          <Form.Control
                            placeholder="Confirm Password"
                            type="password"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => {
                              changeInput(e);
                              validator.current.showMessageFor("confirmPassword");
                            }}
                            autoComplete="off"
                          />
                        </div>
                        {validator.current.message(
                          "confirmPassword",
                          confirmPassword,
                          "required|passwordMatch"
                        )}
                      </InputGroup>
                      <br />
                    </Card.Body>
                    <Card.Footer>

                      <Button
                        className="btn-round mb-3 w-100"
                        variant="warning"
                        onClick={(e) => { postLogIn(e) }}
                      >
                        change Password
                      </Button>
                      <NavLink className="mt-5" to='/auth/forgot'>don't get Verification Code</NavLink>
                    </Card.Footer>

                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
          <div
            className="full-page-background"
          // style={{
          //   backgroundImage: `url(${require("assets/img/bg/fabio-mangione.jpg")})`
          // }}
          />

        </div>
      </section >
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
